import React from "react";
import { Badge } from "../AgentAnalytics/ds";
import { formatLabel, isVideo } from "./formatters";

export default function FormatBadge({ item }) {
  return (
    <Badge tone={isVideo(item) ? "info" : "neutral"} subtle data-testid="format-badge">
      {formatLabel(item)}
    </Badge>
  );
}
